// extracted by mini-css-extract-plugin
export default {"container":"Etage_container__TR8lK","last":"Etage_last__ulOpT"};